import {createSlice, PayloadAction} from '@reduxjs/toolkit'; 

type InitialState ={
    value:bidangState;
}

type bidangState = {
    bidang:string
}


const initialState = {
    value:{
        bidang:''
    } as bidangState, 
     
} as InitialState

export const bidang = createSlice({
    name:'bidang',
    initialState,
    reducers:{
        defaultbidang:()=>{
            return initialState
        },
        setbidang:(state,action:PayloadAction<string> )=>{
            return {
                value:{
                    bidang:action.payload 
                }
            }
        }
    } 
});

export const {defaultbidang, setbidang} = bidang.actions
export default bidang.reducer